export const categoryIcons = {
  branch: { icon: 'ChevronRight', color: '#FF0000' },
  news: { icon: 'File', color: '#0047FF' },
  education: { icon: 'Education', color: '#FF8F00' },
  travelling: { icon: 'Travel', color: '#8CD000' },
  depot: { icon: 'Depot', color: '#0047FF' },
  mobility: { icon: 'Mobility', color: '#00ACD3' },
  precaution: { icon: 'PiggyRight', color: '#9B348E' },
  career: { icon: 'Coins', color: '#FFC900' },
  family: { icon: 'HeartLine', color: '#D14800' },
  habitation: { icon: 'Living', color: '#00724B' },
};
